import React, {useState} from 'react';
import PropTypes from 'prop-types';
import XIcon from '../../../../../../../../assets/icons/XIcon';
import EditSquareIcon from '../../../../../../../../assets/icons/EditSquareIcon';
import CheckIcon from '../../../../../../../../assets/icons/CheckIcon';
import SilverButton from '../../../../../../../../components-new/buttons/SilverButton';
import Tooltip from '../../../../../../../../components-new/general/Tooltip';
import './HardcodedMessages.css';

const MessageEditControls = ({editing, handleEditIconClick, handleCancel, handleSave}) => {
    const [saving, setSaving] = useState(false);

    const save = async () => {
        setSaving(true);
        try {
            await handleSave();
        } finally {
            setSaving(false);
        }
    };

    if (editing) {
        return (
            <div className="hcm-card__controls">
                <Tooltip text="cancel" deltaY={-7}>
                    <SilverButton type="button" size="sm" iconOnly width="32px"
                                  disabled={saving} onClick={handleCancel}>
                        <XIcon width={18} height={18} stroke="currentColor"/>
                    </SilverButton>
                </Tooltip>
                <Tooltip text="save" deltaY={-7}>
                    <SilverButton type="button" size="sm" iconOnly width="32px"
                                  disabled={saving} onClick={save}>
                        <CheckIcon width={18} height={18} stroke="currentColor"/>
                    </SilverButton>
                </Tooltip>
            </div>
        );
    }

    return (
        <div className="hcm-card__controls">
            <Tooltip text="edit" deltaY={-7}>
                <SilverButton type="button" variant="soft" size="sm" iconOnly width="32px"
                              onClick={handleEditIconClick}>
                    <EditSquareIcon width={18} height={18} stroke="currentColor"/>
                </SilverButton>
            </Tooltip>
        </div>
    );
};

MessageEditControls.propTypes = {
    editing: PropTypes.bool.isRequired,
    handleEditIconClick: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleSave: PropTypes.func.isRequired,
};

export default MessageEditControls;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/configurations/components/MessageEditControls.jsx